import Immutable from "immutable";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

import Installment from "state/school_money/entities/OtherPayment/Installment";

export const OtherPayment = new Immutable.Record({
  ...studentLinked.defaultProperties,
  remotePaymentID: undefined,
  remoteInstallmentID: undefined,
  description: undefined,
  isPartial: undefined,
  isVoluntary: undefined,
  isOfflineOnly: undefined,
  requiresParentalConsent: undefined,
  isParentalConsentGiven: undefined,
  hasLimitedPlaces: undefined,
  placesTotal: undefined,
  placesAvailable: undefined,
  isPlaceReserved: undefined,
  installments: undefined
}, "Other Payment");

function buildOtherPaymentFromAppserver(rawPayment) {
  const rawOtherPayment = rawPayment.payload;
  // TODO: fix on server end (hopefully?)
  rawPayment.student_fk = rawOtherPayment.student_fk;
  const props = {
    ...studentLinked.appserverAdapter(rawPayment),
    remotePaymentID: rawOtherPayment.payment_fk,
    remoteInstallmentID: rawOtherPayment.installment_fk,
    description: rawOtherPayment.description,
    isPartial: rawOtherPayment.partial_payment,
    isVoluntary: rawOtherPayment.voluntary_payment,
    isOfflineOnly: rawOtherPayment.offline_only,
    requiresParentalConsent: rawOtherPayment.requires_parental_consent,
    isParentalConsentGiven: rawOtherPayment.consent_date !== "",
    hasLimitedPlaces: rawOtherPayment.total_places !== -1,
    isPlaceReserved: rawOtherPayment.is_place_reserved,
    installments: buildInstallmentsFromAppserver(rawOtherPayment)
  };
  props.placesTotal = props.hasLimitedPlaces ? rawOtherPayment.total_places : null;
  props.placesAvailable = props.hasLimitedPlaces ? props.placesTotal - rawOtherPayment.places_taken : null;
  return OtherPayment(props);
}

function buildInstallmentsFromAppserver(rawOtherPayment) {
  return new Immutable.Map(rawOtherPayment.installments).map(Installment.fromAppserver);
}

export { Installment };
OtherPayment.Installment = Installment;
OtherPayment.fromAppserver = buildOtherPaymentFromAppserver;
export default OtherPayment;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/OtherPayment/index.js